import { useState, useEffect } from 'react';
import CloseIcon from '../../assets/close.svg';
import { useTranslation } from 'react-i18next';
import AddNewAddressModal from './AddNewAddressModal';
import { IoLocationSharp } from 'react-icons/io5';
import { useUser } from '../../contexts/user';
import useToast from '../../hooks/useToast';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';
import Toast from '../Toast';


const SelectAddressModal = ({ isSelectAddressModalOpen, onSelectAddress, onClose }) => {
  const { t } = useTranslation();
  useBodyScrollLock(isSelectAddressModalOpen);
  const [show, setShow] = useState(false);
  const [isAddNewAddressModalOpen, setIsAddNewAddressModalOpen] = useState(false);
  const { user } = useUser();
  const { toastMessage, toastType, showToast } = useToast();

  useEffect(() => {
    if (isSelectAddressModalOpen) {
      setTimeout(() => setShow(true), 10);
    } else {
      setShow(false);
    }
  }, [isSelectAddressModalOpen]);

  const handleAddNewAddressModal = () => {
    setIsAddNewAddressModalOpen(!isAddNewAddressModalOpen);
  };

  const handleAddressUpdated = (newLocations) => {
    onSelectAddress(newLocations[0]);
    onClose();
  };

  const handleCloseAll = () => {
    setIsAddNewAddressModalOpen(false);
    setShow(false);
    onClose();
  };

  return (
    <div>
      <div className={`fixed bottom-0 lg:top-0 left-0 w-full lg:w-[550px] h-fit lg:h-full max-h-[85dvh] lg:max-h-full overflow-y-auto bg-[#f3f3f4] z-50 transition-transform duration-300 ${show ? 'modalanimated' : 'whennotmodalclose'}`}>
        {/* Header */}
        <div className='flex justify-between items-center w-full p-4'>
          <h2 className='font-medium text-xl text-[#000000de]'>{t('Select Address')}</h2>
          <button
            className='w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 hover:bg-[#e7e6e6bf]'
            onClick={onClose}
          >
            <img src={CloseIcon} alt="CloseIcon" />
          </button>
        </div>

        <div className="px-4 space-y-4">
          {user?.locations?.map((location, idx) => (
            <button
              key={idx}
              className="bg-white p-3 rounded flex items-start gap-3 w-full text-left hover:bg-[#d3d3d3] transition-colors"
              onClick={() => {
                if (location.addressNumber) {
                  onSelectAddress(location);
                  onClose();
                } else {
                  showToast(t('selectAddressError'), 'warning');
                }
              }}
            >
              <IoLocationSharp className="text-xl text-[#9d9d9d] flex-shrink-0 mt-0.5" />
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-[#000000DE]">
                  {t(location.addressType) || `${t('address')} ${idx + 1}`}
                </span>
                <span className="text-sm text-[#777] line-clamp-2">
                  {location.addressNumber ? (
                    <div>{location.addressNumber},&nbsp;{location.formattedAddress}</div>
                  ) : (<div>{location.formattedAddress}</div>)}
                </span>
              </div>
            </button>
          ))}
        </div>
                
        <button onClick={handleAddNewAddressModal} className='px-5 bg-[#0B1223] h-11 mt-8 text-white text-sm font-medium btnshadowOne rounded w-full text-center transition-all duration-300 hover:bg-opacity-90'>{t('Add New Address')}</button>

        {
          isAddNewAddressModalOpen && (
            <AddNewAddressModal
              onClose={handleAddNewAddressModal}
              isAddNewAddressModalOpen={isAddNewAddressModalOpen}
              onAddressUpdated={handleAddressUpdated}
              isEdit={false}
            />
          )
        }

      </div>

      {/* Overlay */}
      <div
        className={`fixed top-0 left-0 w-full h-dvh bg-[#212121] bg-opacity-[0.46] z-40 transition-opacity duration-300 ${
          show ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={handleCloseAll}
      />
      <Toast message={toastMessage} type={toastType} />
    </div>
  );
};

export default SelectAddressModal;
